// loads scripts that need to be on page - every entrypoint should import this!
import './kickstart';

// packages
import yall from 'yall-js';
import 'intersection-observer';
import Scroller from '@newswire/scroller';
import resizer from './ai2html-resizer';

// start the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

// maintain slab figure aspect ratio on reload

var slab = document.querySelectorAll('.slab-container');

window.addEventListener('load', () => {
  var minHeight = document.querySelector('.pristine-slab').offsetHeight;

  slab.forEach(function (b) {
    b.style.setProperty('height', `${minHeight}px`);
  });
});

window.addEventListener('resize', () => {
  // We execute the same script as before
  var vh = document.querySelector('.pristine-slab').offsetHeight;
  console.log(vh);
  slab.forEach(function (b) {
    b.style.setProperty('height', `${vh}px`);
  });
});

// scroller
const scroller = new Scroller({
  scenes: document.querySelectorAll('.section2'),
});

// Scroller has a tiny event emitter embedded in it!

// the `enter` event is triggered every time a scene crosses the threshold
scroller.on('scene:enter', (d) => {
  d.element.classList.add('active');
});

// the `exit` event is triggered every time a scene exits the threshold
scroller.on('scene:exit', (d) => {
  //d.element.classList.remove('active');
});

scroller.on('init', () => {});

// starts up the IntersectionObserver
scroller.init();
